import React, { useEffect, useState } from "react";
import './AministradorTabla.scss'
import InputText from "../../../components/atoms/InputText/InputText";
import { DataTable } from "primereact/datatable";
import Button from "../../../components/atoms/Button/Button";
import { Column } from "primereact/column";
import { eliminarPermiso, getTable } from "../AdministradorIntegracion";
import { useNavigate } from "react-router-dom";


const AministradorTabla = () => {
    const navigate = useNavigate()
    const [usuarios, setUsuarios] = useState();

    const [globalFilter, setGlobalFilter] = useState(''); // Estado para el filtro global

    useEffect(()=>
    {
        getTable(setUsuarios)
    },[])
    // Template para la columna de acciones
    const accionesTemplate = (rowData) => {
        return (
            <div className="contenedor-acciones">
                <Button  onClick={() => navigate(`/administrador/editar/${rowData.ID_USUARIO}/${rowData.ID_MODULO}`)} >Editar</Button>
                <Button  onClick={() => {eliminar(rowData)}} > eliminar</Button>
            </div>
        );
    };
    const eliminar = async (rowData)=>
    {
       await eliminarPermiso(rowData)
       getTable(setUsuarios)
    }
    const editarUsuario = (usuario) => {
        // Lógica para editar el usuario
    };

    const eliminarUsuario = (usuario) => {
        // Lógica para eliminar el usuario
    };

    const header = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                    type="search"
                    placeholder="Buscar..."
                    title=""
                    onChange={(e) => setGlobalFilter(e.target.value)}
                />
            </span>
            <Button className={"boton_crear"} onClick={()=>{navigate("/administrador/agregar")}}>Agregar</Button>
        </div>
    );

    return (
        <div className="AministradorTabla">
            <DataTable
                value={usuarios}
                paginator
                rows={9}
                header={header}
                globalFilter={globalFilter}
                responsiveLayout="scroll"
            >
                <Column field="ID_USUARIO" header="ID Usuario"></Column>
                <Column field="NOMBRE" header="Nombre"></Column>
                <Column field="MODULO" header="Accesos"></Column>
                <Column field="PRIVILEGIOS" header="Privilegios"></Column>
                <Column header="Acciones" body={accionesTemplate}></Column>
            </DataTable>
        </div>
    )
}
export default AministradorTabla